import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { TrackProductCrossSellClick } from '@app/+catalog/store';

/**
 * When the user clicks on a product in the cross-sell module on the product page.
 */
const events = getEvents((action: TrackProductCrossSellClick) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'productCrossSellClick',
      itemPosition: action.payload.productPosition,
      product_id: action.payload.productId
    }
  }
]);

export default events;
